import { render, staticRenderFns } from "./Lp.vue?vue&type=template&id=a056a504&"
import script from "./Lp.vue?vue&type=script&lang=js&"
export * from "./Lp.vue?vue&type=script&lang=js&"
import style0 from "./Lp.vue?vue&type=style&index=0&id=a056a504&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports